import { createSelector } from 'reselect';
import {
    get,
    isEqual
} from 'lodash';
import { TABLE_UNMOUNT } from '../Table/tableActions';
import {
    TRANSACTIONS_CLEAR_SEARCH,
    TRANSACTIONS_FAILURE,
    TRANSACTIONS_LOAD,
    TRANSACTIONS_SUCCESS,
    TRANSACTIONS_CARDTYPES_FAILURE,
    TRANSACTIONS_CARDTYPES_LOAD,
    TRANSACTIONS_CARDTYPES_SUCCESS,
    TRANSACTIONS_SEARCH_LOAD,
    TRANSACTIONS_SEARCH_SUCCESS,
    TRANSACTIONS_SEARCH_FAILURE,
    TRANSACTIONS_TOTAL_FAILURE,
    TRANSACTIONS_TOTAL_LOAD,
    TRANSACTIONS_TOTAL_SUCCESS, TRANSACTIONS_COUNT_LOAD, TRANSACTIONS_COUNT_SUCCESS, TRANSACTIONS_COUNT_FAILURE
} from './transactionsActions';
import { getEntityByName } from '../appEntities';

export default function reducer(state = { cardTypesLoading: false, totalLoading: false, transactionsLoading: false }, action = {}) {
    let newState;

    switch (action.type) {
        case TABLE_UNMOUNT:
            newState = {
                ...state,
                transactions: []
            };

            return isEqual(state, newState) ? state : newState;

        case TRANSACTIONS_CLEAR_SEARCH:
            newState = {
                ...state,
                searchTransactions: []
            };

            return isEqual(state, newState) ? state : newState;

        case TRANSACTIONS_LOAD:
            newState = {
                ...state,
                error: null,
                count: 0,
                transactions: [],
                pages: 0,
                hasMore: false,
                offset: 0,
                limit: 10,
                transactionsLoading: true
            };

            return isEqual(state, newState) ? state : newState;

        case TRANSACTIONS_SUCCESS:
            newState = {
                ...state,
                count: action.count,
                pages: action.pages,
                hasMore: action.hasMore,
                offset: action.offset,
                limit: action.limit,
                transactions: action.transactions,
                transactionsLoading: false
            };

            return isEqual(state, newState) ? state : newState;

        case TRANSACTIONS_FAILURE:
            newState = {
                ...state,
                error: action.error,
                transactionsLoading: false
            };

            return isEqual(state, newState) ? state : newState;

        case TRANSACTIONS_TOTAL_LOAD:
            newState = {
                ...state,
                totalError: null,
                totalLoading: true
            };

            return isEqual(state, newState) ? state : newState;

        case TRANSACTIONS_TOTAL_SUCCESS:
            newState = {
                ...state,
                totalLoading: false,
                transactionsTotal: action.transactionsTotal
            };

            return isEqual(state, newState) ? state : newState;

        case TRANSACTIONS_TOTAL_FAILURE:
            newState = {
                ...state,
                totalError: action.error,
                totalLoading: false,
                transactionsTotal: 0
            };

            return isEqual(state, newState) ? state : newState;

        case TRANSACTIONS_COUNT_LOAD:
            newState = {
                ...state,
                countError: null,
                countLoading: true
            };

            return isEqual(state, newState) ? state : newState;

        case TRANSACTIONS_COUNT_SUCCESS:
            newState = {
                ...state,
                countLoading: false,
                transactionsCount: action.transactionsCount
            };

            return isEqual(state, newState) ? state : newState;

        case TRANSACTIONS_COUNT_FAILURE:
            newState = {
                ...state,
                countError: action.error,
                countLoading: false,
                transactionsCount: 0
            };

            return isEqual(state, newState) ? state : newState;

        case TRANSACTIONS_CARDTYPES_LOAD:
            newState = {
                ...state,
                cardTypesError: null,
                cardTypesLoading: true
            };

            return isEqual(state, newState) ? state : newState;

        case TRANSACTIONS_CARDTYPES_SUCCESS:
            newState = {
                ...state,
                cardTypes: action.cardTypes,
                cardTypesLoading: false
            };

            return isEqual(state, newState) ? state : newState;

        case TRANSACTIONS_CARDTYPES_FAILURE:
            newState = {
                ...state,
                cardTypes: [],
                cardTypesError: action.error,
                cardTypesLoading: false
            };

            return isEqual(state, newState) ? state : newState;

        case TRANSACTIONS_SEARCH_LOAD:
            newState = {
                ...state,
                searchError: null,
                searchLoaded: false,
                searchLoading: true,
                searchTransactions: []
            };

            return isEqual(state, newState) ? state : newState;

        case TRANSACTIONS_SEARCH_SUCCESS:
            newState = {
                ...state,
                searchLoaded: true,
                searchLoading: false,
                searchTransactions: action.transactions
            };

            return isEqual(state, newState) ? state : newState;

        case TRANSACTIONS_SEARCH_FAILURE:
            newState = {
                ...state,
                searchError: action.error,
                searchLoaded: true,
                searchLoading: false
            };

            return isEqual(state, newState) ? state : newState;

        default:
            return state;
    }
}

export const getTransactionsEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'transactions')
);

export const getIsCountLoading = createSelector(
    getTransactionsEntity,
    (entity) => get(entity, 'countLoading')
);

export const getIsTransactionsLoading = createSelector(
    getTransactionsEntity,
    (entity) => get(entity, 'transactionsLoading')
);

export const getIsCardTypesLoading = createSelector(
    getTransactionsEntity,
    (entity) => get(entity, 'cardTypesLoading')
);

export const getIsTotalLoading = createSelector(
    getTransactionsEntity,
    (entity) => get(entity, 'totalLoading')
);

export const getTransactionsError = createSelector(
    getTransactionsEntity,
    (entity) => get(entity, 'error')
);

export const getTransactionsErrorMessage = createSelector(
    getTransactionsError,
    (error) => get(error, 'message')
);

export const getTransactionsTotalError = createSelector(
    getTransactionsEntity,
    (entity) => get(entity, 'totalError')
);

export const getTransactionsTotalErrorMessage = createSelector(
    getTransactionsTotalError,
    (error) => get(error, 'message')
);

export const getTransactionsCardTypesError = createSelector(
    getTransactionsEntity,
    (entity) => get(entity, 'cardTypesError')
);

export const getTransactionsCardTypesErrorMessage = createSelector(
    getTransactionsCardTypesError,
    (error) => get(error, 'message')
);

export const getSearchTransactionsError = createSelector(
    getTransactionsEntity,
    (entity) => get(entity, 'searchError')
);

export const getSearchTransactionsErrorMessage = createSelector(
    getSearchTransactionsError,
    (error) => get(error, 'message')
);

export const getTransactions = createSelector(
    getTransactionsEntity,
    (entity) => get(entity, 'transactions')
);

export const getPages = createSelector(
    getTransactionsEntity,
    (entity) => get(entity, 'pages')
);

export const getCount = createSelector(
    getTransactionsEntity,
    (entity) => get(entity, 'transactionsCount')
);

export const getHasMore = createSelector(
    getTransactionsEntity,
    (entity) => get(entity, 'hasMore')
);

export const getTotal = createSelector(
    getTransactionsEntity,
    (entity) => get(entity, 'transactionsTotal')
);

export const getCardTypes = createSelector(
    getTransactionsEntity,
    (entity) => get(entity, 'cardTypes')
);

export const getSearchTransactions = createSelector(
    getTransactionsEntity,
    (entity) => get(entity, 'searchTransactions')
);

export const getIsSearchTransactionsLoading = createSelector(
    getTransactionsEntity,
    (entity) => get(entity, 'searchLoading')
);

export const getIsSearchTransactionsLoaded = createSelector(
    getTransactionsEntity,
    (entity) => get(entity, 'searchLoaded')
);
